export const dispatchCartErrorToast = (store, error) => {
  if (!store || !error) return;
  const status = error.status ?? null;
  const message =
    error.message ||
    error.body?.description ||
    "Unable to add to cart.";

  const payload = {
    message,
    type: "error",
  };

  if (status === 429) {
    payload.action = {
      label: "Refresh page",
      type: "refresh",
    };
    payload.duration = 0;
  }

  store.dispatch("toast/show", payload);
};
